export default __webpack_public_path__ + "static/media/33.dfcc27a8.png";